// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"4f0d39c8","123":"ce9feeb0","607":"b38bb976","719":"848b7921","804":"b209cb32"}[chunkId] + ".chunk.css";
};